import React, { ReactElement } from "react";

import FormItemWrapperProps from "./FormItemWrapperProps";

const FormItemWrapper = ({ children }: FormItemWrapperProps): ReactElement => (
    <>{children}</>
);

export default React.memo(FormItemWrapper);
